import clsx from 'clsx'
import NextImage from 'next/legacy/image'
import Link from 'next/link'
import type { FunctionComponent } from 'react'
import { ellipsedText } from '../../const/EllipsedTextHelper'
import { useTranslate } from '../../contexts/TranslationContext'
import style from './BlogCarouselCard.module.sass'

type BlogCarouselCardProps = {
	title: string
	lead: string | undefined
	url: string
	imageUrl: string | undefined
	isStatic?: boolean
}

export const BlogCarouselCard: FunctionComponent<BlogCarouselCardProps> = ({
	title,
	lead,
	url,
	imageUrl,
	isStatic = false,
}) => {
	const lastCharacterVisible = 100
	const translate = useTranslate()
	return (
		<div className={clsx(style.blogCardWrapper, isStatic && style.blogCardWrapperFour)}>
			<Link href={url} className={style.blogCard} title={title}>
				<h3 className={style.title}>{title}</h3>
				<p className={style.paragraph}>
					{lead && lead.length > lastCharacterVisible ? ellipsedText(lead, lastCharacterVisible) : lead}
				</p>
				<div className={style.imageWrapper}>
					<div className={style.image}>
						<NextImage
							src={imageUrl ?? '/images/placeholder-article.jpg'}
							alt={translate('alternativeText.blogPostPlaceholder')}
							layout="fill"
							objectFit="cover"
						/>
					</div>
				</div>
			</Link>
		</div>
	)
}
